import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const BackButton = () => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1); // Go back to the previous page
    };

    return (
        <button
            onClick={handleBackClick}
            className="flex items-center px-4 py-2 bg-transparent text-gray-700 rounded hover:text-gray-400"
        >
            <ArrowLeft size={16} className="mr-2" />
            Go Back
        </button>
    );
};

export default BackButton;